module.exports = {
    SecertKey: '4d00d244-4974-4689-9bc2-fdc7f3cb0c77',
}


// WEBPACK FOOTER //
// ./src/config/index.js